import Icon from '@ant-design/icons';

const Svg = () => (
  <svg viewBox='0 0 22 18' width='1em' height='1em' fill='currentColor'>
    <path d='M11.01 2.5L9 5H13L11.01 2.5ZM17 7V11L19.5 9.01L17 7ZM5 7L2.5 9.01L5 11V7ZM13 13H9L11.01 15.5L13 13ZM20 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H20C21.1 18 22 17.1 22 16V2C22 0.9 21.1 0 20 0ZM20 16.01H2V1.99H20V16.01Z' />
  </svg>
);

export const CoveragesStepIcon = (props) => {
  return (
    <Icon component={Svg} {...props} />
  );
};